<template>
  <v-card class="ma-2" color="black" variant="outlined" elevation="0">
    <template v-slot:title>
      ДОБАВИТЬ ЭЛЕМЕНТ ОТЧЁТА
    </template>
    <template v-slot:actions>
      <v-sheet color="transparent" class="d-flex justify-space-between align-center">
        <v-btn color="black" variant="flat" class="mr-1" v-on:click="addSection()">РАЗДЕЛ</v-btn>
        <v-btn color="black" variant="flat" v-on:click="addGroup()">СТРАНИЦУ</v-btn>
      </v-sheet>
    </template>
  </v-card>
  <v-divider class="ma-2" v-if="report_data['groups'].length > 0" />
  <v-card class="ma-2" color="black" variant="outlined" elevation="0" v-if="report_data['groups'].length > 0">
    <template v-slot:title>
      СПИСОК НОВЫХ СТРАНИЦ
    </template>
    <template v-slot:actions>
      <draggable
          style="width: 100%;"
          class="group_list"
          :list="report_data['groups']"
          v-bind="dragOptions"
          group="groups"
          @start="drag=true"
          @end="drag=false"
          item-key="id">
        <template #item="{element}">
          <v-text-field
              class="mb-1"
              width="100%"
              color="black"
              density="compact"
              hide-details
              v-model="element.name"
              @click:append-inner="delete_group(element)"
          >
            <template v-slot:append-inner>
              <v-icon style="cursor: pointer" class="trash-btn" :icon="['fas', 'trash']" />
            </template>
          </v-text-field>
        </template>
      </draggable>
    </template>
  </v-card>
  <v-divider class="ma-2" v-if="report_data['unused'].length > 0" />
  <v-card class="ma-2" color="black" variant="outlined" elevation="0" v-if="report_data['unused'].length > 0">
    <template v-slot:title>
      УДАЛЁННЫЕ ОТЧЁТЫ
    </template>
    <template v-slot:actions>
      <draggable
          class="report_list"
          id="unused"
          :list="report_data['unused']"
          v-bind="dragOptions"
          group="reports"
          @start="drag=true"
          @end="checkGroup($event)"
          item-key="id">
        <template #item="{element}">
          <v-alert class="mb-2">
            <template v-slot:text>
              <v-btn disabled :icon="['fas', report_space(element)]" density="compact" variant="tonal">
                <v-icon :icon="['fas', report_space(element)]" />
              </v-btn>
              {{ element['report_description'] }}
            </template>
          </v-alert>
        </template>
      </draggable>
    </template>
  </v-card>
</template>

<script>
import {Rep_Edite_Mode} from "@/store/report/SmallStorrage";
import {CurrentData, CurrentDialog} from "@/store/report/CurrentDialogData";
import {ReportData} from "@/store/report/ReportData";
import draggable from 'vuedraggable'
import randomstring from 'randomstring'
import {Allerts} from "@/store/global/Allerts";

export default {
  name: "RightColumn",
  components: {
    draggable
  },
  methods: {
    report_space: function (report) {
      let chart_cfg = this.$rep_cfg.charts.find(el => el.guid === report['report_guid'])
      return chart_cfg.needSpace.toString()
    },
    checkGroup: function (ev) {
      // Объявляем хранилища для группы источника и группы назначения
      let group_from
      let group_to

      // Находим по ГУИД и записываем группу назначения
      for (let section of this.report_data.section_list) {
        if (section.groups.find(group => group.guid === ev.to.id)) {
          group_to = section.groups[section.groups.indexOf(section.groups.find(group => group.guid === ev.to.id))]
        }
      }
      if (ev.from.id !== 'unused') {
        // Находим по ГУИД и записываем исходную группу
        for (let section of this.report_data.section_list) {
          if (section.groups.find(group => group.guid === ev.from.id)) {
            group_from = section.groups[section.groups.indexOf(section.groups.find(group => group.guid === ev.from.id))]
          }
        }

        // Проверяем, есть ли на целевой странице место для графика
        // Находим, сколько места на странице занимает график
        let chart_cfg = this.$rep_cfg.charts.find(el => el.guid === ev.clone.id.split('_')[2])
        // Сравниваем его с ещё доступным местом
        if (chart_cfg) {
          if (group_to.availableSpace >= chart_cfg.needSpace) {
            // Есть место
            this.drag=false
          } else {
            // Нехватка свободного места, обрабатываем ошибку
            Allerts().warn(
                'ОШИБКА',
                `На странице недостаточно места! Доступное место ${group_to.availableSpace}, необходимое свободное место: ${chart_cfg.needSpace}!`,
                'deep-orange',
                'triangle-exclamation'
            )
            let to_transfer = group_to.reports.find(report => {
              return report.report_guid === ev.item.id.split('_')[2]
            })
            group_from.reports.push(to_transfer)
            group_to.reports.splice(group_to.reports.indexOf(group_to.reports.find(report => report.id === to_transfer.id)), 1)
          }
        } else {
          // Ошибка, данный отчёт не найден в конфигурационном файле
          let to_transfer = group_to.reports.find(report => report.id === ev.item.id)
          group_from.reports.push(to_transfer)
          group_to.reports.splice(group_to.reports.indexOf(group_to.reports.find(report => report.id === to_transfer.id)), 1)
          Allerts().warn('ФАТАЛЬНАЯ ОШИБКА', `Ошибка внутренних типов. Отчёт не найден в конфигурационном файле!`,'black', 'triangle-exclamation')
        }
      } else {
        let chart_cfg = this.$rep_cfg.charts.find(el => el.guid === ev.clone.id.split('_')[2])
        // Сравниваем его с ещё доступным местом
        if (chart_cfg) {
          if (group_to.availableSpace >= chart_cfg.needSpace) {
            // Есть место
            this.drag=false
          } else {
            // Нехватка свободного места, обрабатываем ошибку
            Allerts().warn(
                'ОШИБКА',
                `На странице недостаточно места! Доступное место ${group_to.availableSpace}, необходимое свободное место: ${chart_cfg.needSpace}!`,
                'deep-orange',
                'triangle-exclamation'
            )
            let to_transfer = group_to.reports.find(report => {
              return report.report_guid === ev.item.id.split('_')[2]
            })
            this.report_data.unused.push(to_transfer)
            group_to.reports.splice(group_to.reports.indexOf(group_to.reports.find(report => report.id === to_transfer.id)), 1)
          }
        }
      }
      this.recalculateSpace()
    },
    recalculateSpace: function () {
      this.report_data.section_list.forEach((section) => {
        section.groups.forEach((group) => {
          let freeSpace = 3
          let usedSpace = 0
          if (group.reports.length > 0) {
            group.reports.forEach((report) => {
              let chart = this.$rep_cfg.charts.find(el => el.guid === report.report_guid)
              if (chart) {
                usedSpace += chart.needSpace
              } else {
                usedSpace = 0
              }

            })
          } else {
            usedSpace = 0
          }
          group.availableSpace = freeSpace - usedSpace
        })
      })
    },
    delete_group: function (group) {
      let group_to_remove = this.report_data['groups'].indexOf(this.report_data['groups'].find(g => g['guid'] === group['guid']))
      this.report_data['groups'].splice(group_to_remove, 1);
    },
    addGroup: function () {
      let new_group = [{
        guid: randomstring.generate(16),
        name: `Страница #${randomstring.generate(5)}`,
        type: "group",
        reports: []
      }]
      this.report_data.groups = new_group.concat(this.report_data.groups)
    },
    addSection: function () {
      let new_section = [{
        guid: randomstring.generate(16),
        name: `Раздел #${randomstring.generate(5)}`,
        type: "chart",
        groups: []
      }]
      this.report_data.section_list = new_section.concat(this.report_data.section_list)
    }
  },
  data() {
    return {
      drag: false
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "sections",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    mode: {
      get() {
        return Rep_Edite_Mode().get()
      },
      set(value) {
        return Rep_Edite_Mode().set(value)
      }
    },
    dialog: {
      get() {
        return CurrentDialog().get()
      },
      set(value) {
        CurrentDialog().set(value)
      }
    },
    current: {
      get() {
        return CurrentData().get()
      },
      set(value) {
        CurrentData().set(value)
      }
    },
    report_data: {
      get() {
        return ReportData().get()
      },
      set(value) {
        ReportData().set(value)
      }
    }
  }
}
</script>

<style scoped>

</style>
